import type {ReactNode} from 'react';
import {Navigate} from 'react-router-dom';
import {usePersonalScope, hasAction} from '@api/workspaces';
import {IS_MOCK} from '@api/mock-mode';
import {ErrorState} from '@ui/primitives/ErrorState';
import {PageSkeleton} from '@ui/primitives/PageSkeleton';

/** Action guard рабочего маршрута: без запросов запрещённого экрана. */
export const WorkspaceActionGuard = ({
  children,
  action,
  allowPersonal = false,
}: {
  children: ReactNode;
  action: string;
  allowPersonal?: boolean;
}) => {
  const scope = usePersonalScope();
  if (scope.status === 'error' || scope.status === 'denied')
    return (
      <ErrorState title='Не удалось подтвердить доступ' onRetry={scope.retry} />
    );
  if (!scope.isReady) return <PageSkeleton />;
  if (
    !IS_MOCK &&
    !(allowPersonal && scope.isPersonal) &&
    !hasAction(scope.access, action)
  )
    return <Navigate to='/dashboard' replace />;
  return children;
};
